module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "preloader"
  }, [(_vm.pending) ? _c('md-progress', {
    staticClass: "md-blue",
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), (
    _vm.isLoggedIn &&
    (_vm.$route.path.indexOf('/login') !== 0) &
    (_vm.$route.path.indexOf('/externallogin') !== 0) &
    (_vm.$route.path.indexOf('/quinyx-sign-in') !== 0) &
    (_vm.$route.path.indexOf('/activate') !== 0)
  ) ? _c('wb-nav', {
    attrs: {
      "vuexUsing": true,
      "navbarItems": _vm.navbarItems,
      "profileMenuItems": _vm.profileMenuItems,
      "showItems": _vm.isLoggedIn,
      "navLogo": _vm.logoPath,
      "mainColor": '#43B3FF',
      "backgroundColor": '#0a2052'
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), (
    _vm.isLoggedIn &&
    (_vm.$route.path.indexOf('/login') !== 0) &
    (_vm.$route.path.indexOf('/externallogin') !== 0) &
    (_vm.$route.path.indexOf('/quinyx-sign-in') !== 0) &
    (_vm.$route.path.indexOf('/activate') !== 0)
  ) ? _c('md-icon', {
    class: ['notification-icon', _vm.showSidebar ? 'active' : ''],
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNotification()
      }
    }
  }, [_vm._v("notifications "), _c('i', [_vm._v(_vm._s(_vm.alarmsCount))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-left",
      "enter-active-class": "slideAppear",
      "leave-active-class": "slideDisappear"
    }
  }, [(_vm.showSidebar) ? _c('sidebar', {
    staticClass: "sidebar",
    attrs: {
      "title": _vm.sideBarTitle,
      "headerColor": '#0098FF',
      "type": _vm.sideBarType,
      "data": _vm.sideBarData
    },
    on: {
      "closeSidebar": _vm.closeSidebar
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": 'bottom left',
      "md-duration": 2000
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.message))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05d12b0f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 297
// module chunks = 2